import moment from 'moment-timezone';

/**
 * Transform String date UTC into moment date with timezone.
 * @param {*} dateString : String date
 * @param {*} event : Event object
 */
export function transformDateStringUtcIntoDate(dateString, event) {
    return moment.utc(dateString).tz(event.timezone);
}

/**
 * Return date on format 'YYYY-MM-DD' in the event timezone of a date with any format.
 * @param {*} date : String date || Date object || Moment object
 * @param {*} event : Event object
 */
export function getDayFromDate(date, event) {
    return moment
        .utc(date)
        .tz(event.timezone)
        .format('YYYY-MM-DD');
}

/**
 * Return date on format 'HH:mm' in the event timeZone od a date with any format
 * @param {*} date
 * @param {*} event
 */
export function getHoursFromDate(date, event) {
    return moment
        .utc(date)
        .tz(event.timezone)
        .format('HH:mm');
}

/**
 * Return string date + time localized for display
 * @param dateString
 * @param timezone
 * @param locale
 * @returns {string}
 */
export function formatDateTime(dateString, timezone, locale) {
    let tzDate = moment.utc(dateString).tz(timezone);
    const formatter_date = new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'short', timeZone: timezone });
    return formatter_date.format(tzDate);
}

/**
 * Return string date + time localized for display, with weekday, date, and time
 *
 * @param {string|Date} date
 * @param {string} locale
 * @param {string} timeZone
 * @returns {string} - Formatted date string like "lun. 03/05/2025, 21:00"
 */
export function formatDateForInventories(date, locale, timeZone) {
    const options = {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone
    };

    const formatedDate = new Date(date);
    return formatedDate.toLocaleString(locale, options);
}
